<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <span class="label"></span>
            <div class="cell">
              <select v-model="formData.range">
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="QUARTERLY">분기</option>
              </select>

              <DatePicker v-if="formData.range === 'DAILY'" :value="$utils.calcDate(null, '-1d')" class="blank" ref="picker" :maxDate="new Date()"/>
              <WeekPicker v-if="formData.range === 'WEEKLY'" class="blank" width="300px" ref="picker" :maxDate="new Date()"/>
              <MonthPicker v-if="formData.range === 'MONTHLY'" class="blank" ref="picker" :maxDate="new Date()"/>
              <QuarterPicker v-if="formData.range === 'QUARTERLY'" class="blank" ref="picker" :maxDate="new Date()"/>
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector
              permissionCode="statistic"
              :useGroup="false"
              ref="groupSelector"
              />
            </div>
          </div>
          <div class="row">
            <span class="label">검색</span>
            <div class="cell">
              <select v-model="formData.searchType">
                <option value="NAME">이름</option>
                <option value="TID">TID</option>
              </select>
              <input type="text" class="inp_text blank" style="width:258px" v-model.trim="formData.searchValue">
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <h4 v-if="res" class="section_title">
      <span class="ico"></span>검색결과 : <span class="highlight">{{res.searchCount || 0}}</span>
      <p class="desc">
        <strong>등록된 대상자수</strong> : {{res.userCount || 0}}명
      </p>
    </h4>

    <PagingTable
     :sourceList="tableItems"
     :itemPerPage="50"
     ref="table">
      <template #header>
        <caption><span class="blind">통계 목록</span></caption>
        <colgroup>
          <col width="6%">
          <col width="15%">
          <col width="12%">
          <col width="10%">
          <col width="6%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="6%">
          <col width="6%">
          <col width="6%">
          <col width="6%">
          <col width="6%">
        </colgroup>

        <thead class="table_list_head table_list_head_line">
        <tr>
          <th rowspan="3" class="sorting" data-sort="name">이름</th>
          <th rowspan="3">그룹</th>
          <th rowspan="3">TID</th>
          <th rowspan="3" class="sorting" data-sort="recentDate">최근 이용날짜</th>
          <th v-for="(item, index) in headerInfo" :colspan="getColspan(item.sub)" :key="index" class="center">{{item.name}}</th>
        </tr>
        <tr>
          <template v-for="(item, pi) in headerInfo">
            <th v-for="(subItem, si) in item.sub" :colspan="subItem.sub.length" :key="`${pi}${si}`" class="center">{{subItem.name}}</th>
          </template>
        </tr>
        <tr>
          <template v-for="(item, pi) in headerInfo">
            <template v-for="(subItem, si) in item.sub">
              <th v-for="(lastItem, li) in subItem.sub" :key="`${pi}${si}${li}`" class="center">{{lastItem}}</th>
            </template>
          </template>
        </tr>
        </thead>
      </template>
      <template #row={rowData}>
        <tr>
          <td><button type="button" class="link_modal" @click="$router.push(detailLinkUrl(rowData.rcpId))"><span :class="highlight(rowData.name)">{{getName(rowData.name)}}</span></button></td>
          <td class="left">{{rowData.group}}</td>
          <td class="left">{{rowData.tid}}</td>
          <td>{{rowData.recentDate}}</td>
          <td v-for="(countNum, index) in rowData.statCountList" :key="index" class="right">{{countNum}}</td>
        </tr>
      </template>
    </PagingTable>
  </section>
</template>

<script>
  import defaultData from './Target.default'
  import mixin from './_mixin'

  export default {
    mixins: [ mixin ],
    data() {
      return {
        res: null,
        formData: {
          range: 'WEEKLY',
          state: '', city: '',
          searchType: 'NAME',
          searchValue: '',
        }
      }
    },
    computed: {
      headerInfo() {
        const sample = this.res && this.res.data[0] ? this.res.data[0] : defaultData.data[0]

        return _.map(sample.stat, item => {
          return {
            name: item.name,
            sub: _.map(item.categories, subItem => {
              return {
                name: subItem.categoryName,
                sub: _.map(subItem.categories, lastItem => lastItem.categoryName)
              }
            })
          }
        })
      },
      tableItems() {
        if (!this.res) return null
        return _.map(this.res.data, item => {
          const statCountList = _.map(item.stat, subItem => {
            return _.map(subItem.categories, cateItem => {
              return _.map(cateItem.categories, lastItem => lastItem.count)
            })
          })
          return {
            name: item.name,
            group: item.group,
            tid: item.tid,
            rcpId: item.rcpId,
            recentDate: item.recentDate,
            statCountList: _.flattenDeep(statCountList)
          }
        })
      }
    },
    methods: {
      requestOptions() {
        const startDate = this.$refs.picker.getDate()
        const group = this.$refs.groupSelector.getData()

        return { params: _.merge(this.formData, {
            searchDate: this.$utils.dateformat(startDate, 'yyyy-mm-dd'),
            orgCode: group.orgId,
            state: group.stateId,
            city: group.cityId,
          })}
      },
      detailLinkUrl(id) {
        const url = `/stats/v1/target/${id}`
        return url !== this.$route.path ? url : null
      },
      highlight(val) {
        return val === '미등록' ? 'important' : ''
      },
      getName(val) {
        return val === '미등록' ? '[미등록]' : val
      },
      getColspan(item) {
        let col = 0

        _.forEach(item, subItem => {
          col = col + subItem.sub.length
        })
        return col
      },
      loadData() {
        const options = this.requestOptions()
        this.$axios.get('/admin/happy/stats/user', options).then(({data}) => this.res = data)
      }
    },
    mounted() {
      this.loadData()
    }
  }
</script>
